/**
 * JSON编辑器
 * 依赖：jsoneditor { https://jsoneditoronline.org/}
 */

import EdJsonEditor from './src/EdJsonEditor.vue'

/* istanbul ignore next */
EdJsonEditor.install = function (Vue) {
  Vue.component(EdJsonEditor.name, EdJsonEditor)
}

export default EdJsonEditor
